export const getInvertedIndex = (index: number, length: number) =>
  length - index;
